import { render, staticRenderFns } from "./DialogStockoutOrderAllot.vue?vue&type=template&id=59b1c4d7"
import script from "./DialogStockoutOrderAllot.vue?vue&type=script&lang=js"
export * from "./DialogStockoutOrderAllot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59b1c4d7')) {
      api.createRecord('59b1c4d7', component.options)
    } else {
      api.reload('59b1c4d7', component.options)
    }
    module.hot.accept("./DialogStockoutOrderAllot.vue?vue&type=template&id=59b1c4d7", function () {
      api.rerender('59b1c4d7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/stock/components/DialogStockoutOrderAllot.vue"
export default component.exports